import dayjs from "dayjs";
import { useState } from "react";
import { useSelector } from "react-redux";
import PendingRequest from "./PendingRequest";
import AcceptedRequest from "./AcceptedRequest";
import DeclinedRequest from "./DeclinedRequest";
import Reason from "./Reason";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";

const ManageMonetization = () => {
  const { dialogueType } = useSelector((state) => state.dialogue);

  const [multiButtonSelect, setMultiButtonSelect] = useState("Pending");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <PageContainer className="userPage">
      <PageHeader
        heading={"Welcome Admin"}
        subHeading={"Monetization Request"}
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <MultiButton
        label={["Pending", "Accepted", "Declined"]}
        multiButtonSelect={multiButtonSelect}
        setMultiButtonSelect={setMultiButtonSelect}
      />

      {multiButtonSelect == "Pending" && (
        <PendingRequest
          endDate={endDateData}
          startDate={startDateData}
          multiButtonSelectNavigate={setMultiButtonSelect}
        />
      )}
      {multiButtonSelect == "Accepted" && (
        <AcceptedRequest endDate={endDateData} startDate={startDateData} />
      )}
      {multiButtonSelect == "Declined" && (
        <DeclinedRequest endDate={endDateData} startDate={startDateData} />
      )}
      {dialogueType === "monetization" && <Reason />}
    </PageContainer>
  );
};

export default ManageMonetization;
